import operations from "../../../services/Trade";

export const useUsdtPrice = () => {
  let usdtPrice = { type: "", USDTIRT: 0 };

  const storedPrice = sessionStorage.getItem("usdtPrice");
  const parseStoredPrice = JSON.parse(storedPrice);

  if (parseStoredPrice?.USDTIRT > 0) {
    usdtPrice = parseStoredPrice;
  } else {
    operations
      .getUsdtPrice()
      .then((result) => {
        usdtPrice = { USDTIRT: result.USDTIRT, type: "usdt-price" };
        sessionStorage.setItem("usdtPrice", JSON.stringify(usdtPrice));
      })
      .catch((err) => {
        console.error("Error fetching USDT price:", err);
      });
  }

  return usdtPrice;
};
